import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';

import { Button } from '../index';
import { useStateContext } from '../../contexts/ContextProvider';
import {AccountStore} from "../../stores/account/accountStore";
import {Assets} from "../../assets";
interface UserProfileData {
  icon: string;
  title: string;
  desc: string;
  iconColor: string;
  iconBg: string;
}

const userProfileData: UserProfileData[] = [];


const UserProfile = () => {
  const { currentColor } = useStateContext();
  const user = AccountStore().profile;
  return (
    <div className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">Perfil do Usuário</p>
        <Button
          icon={React.createElement(MdOutlineCancel as any)}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
        />
      </div>
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
        <img
          className="rounded-full h-24 w-24"
          src={Assets.avatar_user}
          alt="user-profile"
        />
        <div>
          <p className="font-semibold text-xl dark:text-gray-200"> {user.name} </p>
          <p className="text-gray-500 text-sm dark:text-gray-400">  Administrador   </p>
          <p className="text-gray-500 text-sm font-semibold dark:text-gray-400"> {user.email} </p>
        </div>
      </div>
      <div>
        {userProfileData.map((item: UserProfileData, index: number) => (
          <div key={index} className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]">
            <button
              type="button"
              style={{ color: item.iconColor, backgroundColor: item.iconBg }}
              className=" text-xl rounded-lg p-3 hover:bg-light-gray"
            >
              {item.icon}
            </button>

            <div>
              <p className="font-semibold dark:text-gray-200 ">{item.title}</p>
              <p className="text-gray-500 text-sm dark:text-gray-400"> {item.desc} </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-5">
        <Button
          callback={()=> AccountStore().logout()}
          color="white"
          bgColor={currentColor}
          text="Sair"
          borderRadius="10px"
          width="full"
        />
      </div>
    </div>

  );
};

export default UserProfile;
